/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { MainPageContainer, OSDrawer } from "theme/components";
import { Box } from "ui-widgets";
import { SessionMonitor } from "authentication";
import CssBaseline from "@mui/material/CssBaseline";
import { useGlobalScope } from "core/providers";
import { APIItemDisplayWrapper } from "ui-widgets/wrappers/APIRequestWrappers";
import "theme/css/ProtectedTheme.css";

interface ProtectedBaseLayoutProps {
  hideOrganizationSelect?: boolean;
  hideDrawer?: boolean;
  children: React.ReactNode;
}

export const ProtectedBaseLayout = (props: ProtectedBaseLayoutProps) => {
  const drawerComponent = !props.hideDrawer && <OSDrawer />;

  const {
    globalState: { selectedOrganization, isGlobalOrganizationFetchError, globalOrganizationFetchStatusCode },
  } = useGlobalScope();

  return (
    /* 
    Wrap our Base Page around some global providers:

     Theme Provider: Sets the global theme for our App

    */
    <>
      <CssBaseline />
      <SessionMonitor />
      <Box className="os-protected-base-container">
        {drawerComponent}
        <MainPageContainer>
          <APIItemDisplayWrapper
            showLoader={false}
            isAPIError={isGlobalOrganizationFetchError}
            httpResponseStatusCode={globalOrganizationFetchStatusCode}
          >
            {selectedOrganization ? props.children : null}
          </APIItemDisplayWrapper>
        </MainPageContainer>
      </Box>
    </>
  );
};
